import { createSelector } from 'reselect';
import type { RootState } from '@/redux/types';

export const getUserState = createSelector(
  (state: RootState) => state,
  state => state.user
);

export const getUserId = createSelector(
  (state: RootState) => state.user,
  user => user.id
);

export const getUserFirstname = createSelector(
  (state: RootState) => state.user,
  user => user.firstname
);

export const getUserLastname = createSelector(
  (state: RootState) => state.user,
  user => user.lastname
);

export const getUserUsername = createSelector(
  (state: RootState) => state.user,
  user => user.username
);

export const getUserEmail = createSelector(
  (state: RootState) => state.user,
  user => user.email
);

export const getUserPoints = createSelector(
  (state: RootState) => state.user,
  user => user.points
);

export const getUserTeamId = createSelector(
  (state: RootState) => state.user,
  user => user.teamId
);

export const getUserEntityData = createSelector(
  (state: RootState) => state.user,
  user => user.data
);

export const getUserReadonlyData = createSelector(
  (state: RootState) => state.user,
  user => user.readonlyData
);

export const getUserPrize = createSelector(
  (state: RootState) => state.user,
  user => user.prize
);

export const getUserLanguage = createSelector(
  (state: RootState) => state.user,
  user => user.language
);
